module.exports = __webpack_public_path__ + "static/media/Reine3.d7da09e9.jpg";